import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/AboutBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/app/components/Navbar.tsx");
